import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useEnrollInStyles2 = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  enrollBlock: {
    padding: '24px 40px',
    '& .MuiSvgIcon-root': {
      marginRight: '10px'
    }
  },
  menuItem: {
    display: 'flex',
    justifyContent: 'space-between'
  },
  selector: {
    width: '100%',
    '&:nth-child(2)': {
      marginLeft: '10px'
    },
    '& .MuiChip-root': {
      display: 'none'
    }
  }
}));
export default useEnrollInStyles2;